export var WHATSAPP = 'whatsapp';
export var MESSENGER = 'facebook_messenger';
export var TELEGRAM = 'telegram';
export var SMS = 'sms';
export var NOT_DISTURB = 'not_disturb';
export var EMAIL = 'email';